import { render, staticRenderFns } from "./MasterList.vue?vue&type=template&id=1c9bf2f5"
import script from "./MasterList.vue?vue&type=script&lang=js"
export * from "./MasterList.vue?vue&type=script&lang=js"
import style0 from "./MasterList.vue?vue&type=style&index=0&id=1c9bf2f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports